import {
  BillingLineContext,
  BillingLinePartyType,
  BillingLineSide,
} from '@treadinc/horizon-api-spec';

import { SettlementSearchParamName } from '~store/SettlementsStore';
import isEnumValue from '~utils/isEnumValue';

export type DraftSettlementsParty = Pick<BillingLineContext['party'], 'id' | 'type'>;

const draftSettlementsPartyFilterNames = {
  [BillingLinePartyType.ACCOUNT]: {
    [BillingLineSide.PAYABLE]: SettlementSearchParamName.VENDORS,
    [BillingLineSide.RECEIVABLE]: SettlementSearchParamName.CUSTOMERS,
  },
  [BillingLinePartyType.USER]: {
    [BillingLineSide.PAYABLE]: null,
    [BillingLineSide.RECEIVABLE]: null,
  },
} satisfies Record<
  BillingLinePartyType,
  Record<BillingLineSide, SettlementSearchParamName | null>
>;

export function getDraftSettlementsPartyFilterName(
  party: DraftSettlementsParty,
  side: BillingLineSide,
) {
  return isEnumValue(BillingLinePartyType, party.type)
    ? draftSettlementsPartyFilterNames[party.type][side]
    : null;
}

export function canReadDraftSettlementsOfParty(
  party: DraftSettlementsParty,
  side: BillingLineSide,
) {
  return getDraftSettlementsPartyFilterName(party, side) !== null;
}
